import axios from 'axios'

export default {
  doTransactions (payload: any) {
    return new Promise((resolve, reject) => {
      axios.post('/do-transaction', payload).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  checkTransaction (payload: any) {
    return new Promise((resolve, reject) => {
      axios.post('/check-transaction', payload).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getTransactionHistory (url: string, payload: any) {
    return new Promise((resolve, reject) => {
      axios.post(url, payload).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getSpecificUserInfo (payload: any) {
    return new Promise((resolve, reject) => {
      axios.get('/get-user-by-username', {
        params: payload
      }).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  }
}
